// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26TFZ","rootNoMargin":"styles_rootNoMargin__pXp-9"};